// public/v3/src/lib/studio-tasks.js — pure roster → tasks enumerator
// for Studio. Each task is one push target: a patient + program slot +
// billing code. The §9 scenario matrix in the Phase 6 spec is the
// authoritative source for which combinations emit which tasks.
//
// Pure function — no React, no fetches. CommonJS so Jest can read it.

const { resolveBhiBillCode } = require('./bhi-billing.js');
const { isBhiOperationalRow } = require('./workflow.js');

function ccmCodeFor(raw, monthStr) {
  const apcmMap = (raw && raw.apcmMonth && typeof raw.apcmMonth === 'object') ? raw.apcmMonth : {};
  const apcmDecision = apcmMap[monthStr];
  if (apcmDecision && apcmDecision.code) return apcmDecision.code;
  return raw && raw.billing && raw.billing.program;
}

function isCcmEnrolled(raw) {
  return !!(raw && raw.billing && raw.billing.program);
}

function tasksForRoster(patients, monthStr, programFilter) {
  if (!Array.isArray(patients)) return [];
  const tasks = [];
  for (const p of patients) {
    if (!p || !p._raw) continue;
    const raw = p._raw;

    // CCM task: emit when patient is CCM-enrolled. The APCM-decided
    // month path automatically folds G0570 into the CCM combined note
    // downstream (see billing-generate.js getCcmBillingCodes); no
    // separate BHI task in that case.
    if (isCcmEnrolled(raw) && programFilter !== 'bhi') {
      const code = ccmCodeFor(raw, monthStr);
      if (code) tasks.push({ patientId: p.id, patient: p, program: 'ccm', code });
    }

    // BHI task: emit only when (a) standalone path applies — i.e.,
    // resolveBhiBillCode returns '99484' (no APCM decision) — AND
    // (b) BHI is audit-ready per isBhiOperationalRow (enrollment +
    // consent + assessment), AND (c) filter admits BHI.
    if (programFilter !== 'ccm') {
      const bhiCode = resolveBhiBillCode(raw, monthStr);
      if (bhiCode === '99484' && isBhiOperationalRow({ data: raw })) {
        tasks.push({ patientId: p.id, patient: p, program: 'bhi', code: '99484' });
      }
    }
  }
  return tasks;
}

module.exports = { tasksForRoster };
